import { render } from "./EditLeaderBoardContent.vue?vue&type=template&id=43bda620&scoped=true"
import script from "./EditLeaderBoardContent.vue?vue&type=script&lang=js"
export * from "./EditLeaderBoardContent.vue?vue&type=script&lang=js"

import "./EditLeaderBoardContent.vue?vue&type=style&index=0&id=43bda620&lang=scss&scoped=true"
import "./EditLeaderBoardContent.vue?vue&type=style&index=1&id=43bda620&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bda620"]])

export default __exports__